var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWso2Inline = function SvgWso2Inline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 246.065 100"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7300",
    d: "M98.814 33.216 83.101 73.322 67.303 30.43 50.56 73.226l-14.281-40.01h-6.498l20.524 56.189 16.84-42.797 15.781 42.844 22.384-56.236zM130.424 61.764c-2.621-2.142-16.349-9.274-18.115-10.507-1.76-1.229-2.644-3.02-2.644-5.371 0-2.354.897-4.265 2.686-5.733 1.789-1.477 3.967-2.206 6.532-2.206 1.654 0 3.067.318 4.246.964 1.175.643 2.298 1.687 3.364 3.13l.565.876c.157.113.376.38.643.801l4.729-3.042c-1.55-2.727-3.486-4.797-5.814-6.216-2.321-1.414-4.822-2.123-7.489-2.123-4.544 0-8.262 1.279-11.148 3.846-2.882 2.565-4.323 5.858-4.323 9.868 0 3.79 1.303 6.718 3.922 8.773 2.622 2.056 15.685 8.837 17.715 10.227 2.032 1.387 3.043 3.444 3.043 6.171 0 3.1-1.021 5.674-3.082 7.728-2.059 2.063-4.666 3.088-7.813 3.088-2.777 0-5.075-.854-6.89-2.567-1.818-1.712-3.104-4.161-3.851-7.369l-5.773 1.766c.503 2.164 1.238 4.092 2.188 5.771.977 1.714 2.185 3.168 3.626 4.362 2.857 2.382 6.478 3.573 10.863 3.573 4.648 0 8.598-1.595 11.862-4.772 3.256-3.18 4.886-7.067 4.886-11.666 0-4.111-1.308-7.239-3.928-9.372",
    style: {
      fill: "#6c7993",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.726 58.086a15.65 15.65 0 0 1 4.306-.576c4.072 0 7.37 1.318 9.883 3.951 2.522 2.623 3.787 5.723 3.787 9.294 0 2.51-.604 4.862-1.813 7.06-1.2 2.196-3.54 5.18-7.017 8.927l-11.019 11.892h20.443v4.277h-30.074l16.922-18.273c3.428-3.681 5.663-6.405 6.699-8.181 1.037-1.771 1.552-3.645 1.552-5.606 0-2.491-.927-4.637-2.79-6.43-1.854-1.792-4.129-2.694-6.822-2.694-1.54 0-2.936.28-4.197.837.113-1.074.154-4.078.14-4.478",
    style: {
      fill: "#6c7993",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 165.385,
    cy: 59.941,
    fill: "#FF7300",
    fillRule: "evenodd",
    clipRule: "evenodd",
    rx: 24.356,
    ry: 24.616,
    style: {
      fill: "#6c7993",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.385 29.706c-16.745 0-30.319 13.537-30.319 30.235s13.574 30.235 30.319 30.235c16.744 0 30.319-13.537 30.319-30.235s-13.575-30.235-30.319-30.235m0 54.851c-13.451 0-24.356-11.021-24.356-24.616s10.905-24.616 24.356-24.616 24.356 11.021 24.356 24.616-10.905 24.616-24.356 24.616",
    style: {
      fill: "#6c7993",
      fillOpacity: 1
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m189.66 58.023-8.826.021-4.4 7.918-10.98-26.767-9.878 21.988-14.517-.031c.058 1.211.205 2.399.431 3.558l16.385.035 7.43-16.54 10.645 25.949 6.979-12.558 6.752-.016c.035-.542.06-1.088.06-1.639 0-.646-.033-1.284-.081-1.918"
  })));
};
export default SvgWso2Inline;